import ResponsiveModal from 'components/ResponsiveModal/styled';

export default ResponsiveModal;
